import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from "rxjs/Observable";
import { getShowSearchControl } from '../../store/store';
import * as thresholdActions from '../../store/actions/actions';

@Component({
    selector: 'celine-threshold-search-control',
    template: require('./search-control.component.html'),
    styles: [`
        .icon-search { background-image: none; }
    `]
})

export class SearchControlComponent {
    showSearchControl$: Observable<boolean>;

	constructor(private store: Store<any>) {
        this.showSearchControl$ = this.store.select(getShowSearchControl);
    }

    toggleSearchBar() {
        this.store.dispatch(new thresholdActions.ToggleSearchBarAction());
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/components/search/search-control.component.ts